import React from 'react';
import styles from '../../styles/Dashboard/sidebar.module.css';

const Sidebar = ({ activeTab, setActiveTab, highlightedSidebarItem }) => {


  const tabs = [
    { id: 'dashboard', label: '🏠 Dashboard' },
    { id: 'tenant', label: '🗺️ Apartment Search' },
    { id: 'favorites', label: '❤️ Favorites' },
    { id: 'groups', label: '👥 Roommate Groups' },
    { id: 'documents', label: '📄 Documents & Verification' },
	{ id: 'Chat', label: '🤖 MILO GUIDE' },
    { id: 'settings', label: '⚙️ Account Settings' },
  ];

  return (
    <div className={styles.sidebar}>
      <nav>
        {tabs.map(tab => (
			<button
			  key={tab.id}
			  className={`
				${styles.link} 
				${activeTab === tab.id ? styles.active : ''} 
				${highlightedSidebarItem === tab.id ? styles.highlighted : ''}
			  `}
			  onClick={() => setActiveTab(tab.id)}
			>
			  {tab.label}
			</button>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
